/// config.js
///
/// Environment switch (manual):
/// - production: customer-facing production
/// - dev: internal dev/staging environment (develop branch deployments)
/// - preview: short-term preview environment for large UI experiments / PR previews
/// - local: your local machine (localhost)
/// - leia: special tablet/network modes
///
/// IMPORTANT:
/// - When preparing a build, set ENVIRONMENT + ENVIRONMENT_WEBGL explicitly.
/// - Preview builds typically use the dev API (api-dev) but can use preview WebGL.
///
/// Allowed values:
/// - ENVIRONMENT:        "production" | "dev" | "preview" | "local" | "leia"
/// - ENVIRONMENT_WEBGL:  "production" | "dev" | "preview" | "local" | "leia"
/// - LOCATION (leia only): "home" | "hotel" | "gadbad"

export const ENVIRONMENT = "dev";
export const ENVIRONMENT_WEBGL = "dev";
export const LOCATION = "home";
export const REACT_APP_GOOGLE_CLIENT_ID="137306836199-1g3hc0ui5scb3i2nlsetr47afr1un3cd.apps.googleusercontent.com";


export const FASTAPI_BASE_URL =
  ENVIRONMENT === "production"
    ? "https://api.saras-3d.us/api"
    : ENVIRONMENT === "dev"
      ? "https://api-dev.saras-3d.us/api"
      : ENVIRONMENT === "preview"
        ? "https://api-preview.saras-3d.us/api"
        : ENVIRONMENT === "leia"
          ? (LOCATION === "home"
              ? "http://192.168.50.61:5000/api"
              : LOCATION === "hotel"
                ? "http://103.240.169.73:5000/api"
                : "http://localhost:5000/api")
          : "http://localhost:5000/api";

export const WEBGL_BASE_URL =
  ENVIRONMENT_WEBGL === "production"
    ? "https://app.saras-3d.ai/webgl-master"
    : ENVIRONMENT_WEBGL === "dev"
      ? "https://dev.saras-3d.us/webgl-master"
      : ENVIRONMENT_WEBGL === "preview"
        ? "https://preview.saras-3d.us/webgl-master"
        : ENVIRONMENT_WEBGL === "leia"
          ? (LOCATION === "home"
              ? "http://192.168.50.61:5000"
              : LOCATION === "hotel"
                ? "http://103.240.169.73:5000"
                : "http://localhost:5000")
          : "http://localhost:8080/webgl-master";

export const PDF_BASE_URL =
  ENVIRONMENT === "production"
    ? "https://api.saras-3d.us"
    : ENVIRONMENT === "dev"
      ? "https://api-dev.saras-3d.us"
      : ENVIRONMENT === "preview"
        ? "https://api-preview.saras-3d.us"
        : ENVIRONMENT === "leia"
          ? (LOCATION === "home"
              ? "http://192.168.50.61:5000"
              : LOCATION === "hotel"
                ? "http://103.240.169.73:5000"
                : "http://localhost:5000")
          : "http://localhost:5000";


export const JOURNEY_ASSET_BASE_URL =
  `${PDF_BASE_URL}/static/journeys`;

// This automatically produces:

// Local:
// http://localhost:5000/static/journeys

// Dev:
// https://api-dev.saras-3d.us/static/journeys

// Preview:
// https://api-preview.saras-3d.us/static/journeys

// Production:
// https://api.saras-3d.us/static/journeys

// Later, when we move Journey images to S3 or CloudFront, we change only this one constant.

// export const FASTAPI_BASE_URL =
//   ENVIRONMENT === "production"
//     ? "https://api.saras-3d.us/api"
//     : ENVIRONMENT === "leia"
//       ? (LOCATION === "home"
//           ? "http://192.168.50.61:5000/api"
//           : LOCATION === "hotel"
//             ? "http://103.240.169.73:5000/api"
//             : "http://localhost:5000/api")
//       : "http://localhost:5000/api";

// export const WEBGL_BASE_URL =
//   ENVIRONMENT_WEBGL === "production"
//     ? "https://app.saras-3d.ai/webgl-master"
//     : ENVIRONMENT_WEBGL === "leia"
//       ? (LOCATION === "home"
//           ? "http://192.168.50.61:5000"
//           : LOCATION === "hotel"
//             ? "http://103.240.169.73:5000"
//             : "http://localhost:5000")
//       : "http://localhost:8080/webgl-master"; // : "/webgl-master";

// export const PDF_BASE_URL =
//   ENVIRONMENT === "production"
//     ? "https://api.saras-3d.us"
//     : ENVIRONMENT === "leia"
//       ? (LOCATION === "home"
//           ? "http://192.168.50.61:5000"
//           : LOCATION === "hotel"
//             ? "http://103.240.169.73:5000"
//             : "http://localhost:5000")
//       : "http://localhost:5000";

// BDD following pointed to EC2 directly
// // Manually set the environment: change to "production" when needed, or "local" otherwise.
// export const ENVIRONMENT = "production"; // or "local" // or "production"

// // Use the ENVIRONMENT flag to determine the correct URLs.
// export const FASTAPI_BASE_URL =
//   ENVIRONMENT === "production"
//     ? "http://54.173.187.192:5000/api"
//     : "http://localhost:5000/api";

// export const WEBGL_BASE_URL =
//   ENVIRONMENT === "production"
//     ? "http://54.173.187.192:5000"
//     : "http://localhost:5000";